import Contract from "slotworks/utils/contract";
import gameState from "slotworks/model/game-state";
import Components from "slotworks/components/components";
import { parallel, sequence } from "slotworks/utils/race-utils";
import { StaticSymbolsCommand } from "slotworks/commands/symbols/static-symbols-command";
import G288Components from "components/components";
import Layers from "slotworks/graphics/layers/layers";
import soundManager from "slotworks/sound/sound-manager";
import MessagesComponent from "components/messages/messages-component";

export default function CelebrateScatterCommand(): Contract<void> {
    return new Contract(resolve => {
        const record = gameState.getCurrentGame().getCurrentRecord();

        if(!record) {
            resolve(null);
            return;
        }
        const tweenFunctions = [];
        const scatters = Components.matrix.getAllSymbols().filter(symbol => symbol.symbolId == "SCATTER");
        const emitters: {id: number, x: number, y: number}[] = [];
        for(let symbol of scatters) {
            tweenFunctions.push(() => symbol.win());
            const transform = symbol.getTransform();                        
            const layer = symbol.getLayer();                                                
            const front = (layer != Layers.Custom.get("Animations")) ? layer.localToLocal(Layers.Custom.get("Animations"), transform) : transform;              
            emitters.push({ id:symbol.gridPosition.x - 1, x: transform.x + transform.width/2, y: transform.y - transform.height});
        }
        soundManager.customEvent("scatter_win");
        G288Components.scatterEmitter.emitAll(emitters);
        parallel(tweenFunctions).then(() => {
            StaticSymbolsCommand().execute();
            resolve(null);
        });
    });
}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/commands/celebrate-scatter-command.ts